require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-sweet-shopify-plus-success-for-hummingbird-bakery.json") })
        }
      }, "path---blog-sweet-shopify-plus-success-for-hummingbird-bakery");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-sweet-shopify-plus-success-for-hummingbird-bakery!./.cache/json/blog-sweet-shopify-plus-success-for-hummingbird-bakery.json
// module id = 497
// module chunks = 231608221292675